/* sp-home.js — Sweet Pop interakcie (aktualizované 2026-10-12) */
/* Sweet Pop — homepage redesign interactions (dev concept) */
(() => {
  if (window.__spHome) return;
  window.__spHome = true;
  // Preklady hlášok (window.SP_I18N z Liquidu podľa jazyka obchodu); slovenčina je predvolená
  const L = (k, def, vars) => { let t = (window.SP_I18N && window.SP_I18N[k]) || def; if (vars) Object.keys(vars).forEach((v) => { t = t.split('{' + v + '}').join(vars[v]); }); return t; };


  // Theme helpers are top-level consts in base.js (global lexical scope, not window props)
  const themeUtil = () => (typeof HELPER_UTIL !== 'undefined' ? HELPER_UTIL : null);
  const themeEvents = () => (typeof _EVENT_HELPER !== 'undefined' ? _EVENT_HELPER : null);

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window && !reduce
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 })
    : null;

  const initReveal = (root) => {
    root.querySelectorAll('[data-sp-reveal], .sp-hl').forEach((el) => {
      if (io) io.observe(el); else el.classList.add('is-visible');
    });
  };

  /* ---------- Tabs (product discovery) ---------- */
  const initTabs = (root) => {
    root.querySelectorAll('[data-sp-tabs]').forEach((wrap) => {
      const tabs = [...wrap.querySelectorAll('[role="tab"]')];
      const select = (tab) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on);
          t.tabIndex = on ? 0 : -1;
          const panel = wrap.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        wrap.querySelectorAll('[data-sp-rail]').forEach(updateRailNav);
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
          next.focus(); select(next);
        });
      });
    });
  };

  /* ---------- Horizontal rails ---------- */
  const updateRailNav = (rail) => {
    const nav = rail.closest('[data-sp-rail-scope]')?.querySelector('[data-sp-rail-nav]');
    if (!nav) return;
    const prev = nav.querySelector('[data-dir="-1"]');
    const next = nav.querySelector('[data-dir="1"]');
    const visible = rail.offsetParent !== null;
    if (!visible) return;
    prev.disabled = rail.scrollLeft < 8;
    next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8;
  };
  const initRails = (root) => {
    root.querySelectorAll('[data-sp-rail-scope]').forEach((scope) => {
      const nav = scope.querySelector('[data-sp-rail-nav]');
      scope.querySelectorAll('[data-sp-rail]').forEach((rail) => {
        rail.addEventListener('scroll', () => updateRailNav(rail), { passive: true });
        updateRailNav(rail);
      });
      nav?.querySelectorAll('button').forEach((btn) => {
        btn.addEventListener('click', () => {
          const rail = [...scope.querySelectorAll('[data-sp-rail]')].find((r) => r.offsetParent !== null);
          if (!rail) return;
          const card = rail.firstElementChild;
          const step = card ? card.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
          rail.scrollBy({ left: step * Number(btn.dataset.dir), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  };

  /* ---------- Flavour explorer ---------- */
  const initFlavours = (root) => {
    root.querySelectorAll('[data-sp-flav]').forEach((sec) => {
      const btns = [...sec.querySelectorAll('[data-flav-btn]')];
      const panels = [...sec.querySelectorAll('[data-flav-panel]')];
      let timer;
      const show = (i, user) => {
        btns.forEach((b, j) => b.setAttribute('aria-selected', i === j));
        panels.forEach((p, j) => p.classList.toggle('is-active', i === j));
        const b = btns[i];
        sec.style.setProperty('--flav', b.dataset.color);
        sec.classList.toggle('is-dark', b.dataset.dark === 'true');
        if (user) clearInterval(timer);
      };
      btns.forEach((b, i) => {
        b.addEventListener('click', () => show(i, true));
        b.addEventListener('mouseenter', () => { if (window.matchMedia('(hover: hover)').matches) show(i, true); });
      });
      if (!reduce && btns.length > 1 && !document.documentElement.classList.contains('shopify-design-mode')) {
        let cur = 0;
        const start = () => { timer = setInterval(() => { cur = (cur + 1) % btns.length; show(cur); }, 4200); };
        const vis = new IntersectionObserver(([e]) => { clearInterval(timer); if (e.isIntersecting) start(); }, { threshold: 0.4 });
        vis.observe(sec);
        sec.addEventListener('pointerdown', () => { clearInterval(timer); vis.disconnect(); }, { once: true });
        btns.forEach((b) => b.addEventListener('click', () => vis.disconnect(), { once: true }));
      }
      show(0);
    });
  };

  /* ---------- Quick add (uses theme cart drawer when available) ---------- */
  const initQuickAdd = (root) => {
    root.querySelectorAll('[data-sp-add]').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault(); e.stopPropagation();
        if (btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading');
        const id = Number(btn.dataset.variant);
        const hasDrawer = !!document.querySelector('cart-drawer, cart-drawer-component');
        const util = themeUtil(); const ev = themeEvents();
        let sections = '';
        try { if (hasDrawer && util?.sectionRenderUtil) sections = util.sectionRenderUtil('cart-drawer').getSectionsString(); } catch (_) {}
        try {
          const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js${sections ? `?sections=${sections}` : ''}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [{ id, quantity: 1, ...(btn.dataset.preorderName ? { properties: { [btn.dataset.preorderName]: btn.dataset.preorderValue } } : {}) }] }),
          });
          const data = await res.json();
          if (!res.ok) throw data;
          btn.classList.remove('is-loading'); btn.classList.add('is-done');
          setTimeout(() => btn.classList.remove('is-done'), 1800);
          if (hasDrawer && util?.dispatchCustomEvent && ev) {
            window.currentActiveElement = btn;
            util.dispatchCustomEvent(ev.triggerCartChange, btn, { sections: data.sections });
            util.dispatchCustomEvent(ev.showDrawer, document, { drawerType: 'cart-drawer' });
          } else {
            window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
          }
        } catch (err) {
          btn.classList.remove('is-loading');
          const msg = err?.description || err?.message || L('add_fail', 'Produkt sa nepodarilo pridať.');
          if (util?.dispatchCustomEvent && ev) {
            util.dispatchCustomEvent(ev.triggerToastMessage, document, { toastType: 'common-errors', messageType: 'error', message: msg });
          } else { alert(msg); }
        }
      });
    });
  };


  /* ---------- Header height (for sticky elements below the theme's sticky header) ---------- */
  const setHeaderH = () => {
    const h = document.querySelector('sticky-header, .shopify-section-group-header-group.section-header, header');
    if (!h) return;
    const r = h.getBoundingClientRect();
    document.documentElement.style.setProperty('--sp-header-h', `${Math.max(0, Math.round(r.bottom > 0 ? r.height : 0))}px`);
  };

  /* ---------- Hero photo slideshow ---------- */
  const initHeroSlides = (root) => {
    root.querySelectorAll('[data-sp-slides]').forEach((wrap) => {
      const slides = [...wrap.querySelectorAll('.sp-hero__slide')];
      const dots = [...wrap.querySelectorAll('[data-slide-dot]')];
      if (slides.length < 2) return;
      let cur = 0; let timer;
      const go = (i) => {
        cur = (i + slides.length) % slides.length;
        slides.forEach((s, j) => s.classList.toggle('is-active', j === cur));
        dots.forEach((d, j) => d.setAttribute('aria-selected', j === cur));
      };
      const ms = (Number(wrap.dataset.interval) || 6) * 1000;
      const play = () => { if (!reduce) timer = setInterval(() => go(cur + 1), ms); };
      dots.forEach((d) => d.addEventListener('click', () => { clearInterval(timer); go(Number(d.dataset.slideDot)); play(); }));
      document.addEventListener('visibilitychange', () => { clearInterval(timer); if (!document.hidden) play(); });
      play();
    });
  };

  /* ---------- Box builder ---------- */
  const formatMoney = (cents, format) => {
    const f = format || '€{{amount_with_comma_separator}}';
    const v = (Number(cents) || 0) / 100;
    const withSep = (n, dec, thou, decimals = 2) => {
      const [i, d] = n.toFixed(decimals).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? dec + d : '');
    };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_with_comma_separator') return withSep(v, ',', '.');
      if (k === 'amount_no_decimals') return withSep(v, ',', ',', 0);
      if (k === 'amount_no_decimals_with_comma_separator') return withSep(v, ',', '.', 0);
      return withSep(v, '.', ',');
    });
  };

  const initBuilder = (root) => {
    root.querySelectorAll('[data-sp-builder]').forEach((sec) => {
      if (sec.__spBuilder) return; sec.__spBuilder = true;
      const sizes = JSON.parse(sec.querySelector('[data-sizes]')?.textContent || '[]');
      const mode = sec.dataset.mode;
      const discount = Number(sec.dataset.discount) || 0;
      const fmt = sec.dataset.moneyFormat;
      const box = sec.querySelector('[data-box]');
      const slotsEl = sec.querySelector('[data-slots]');
      const tiles = [...sec.querySelectorAll('[data-flavour]')];
      const byId = Object.fromEntries(tiles.map((t) => [t.dataset.id, t]));
      const hint = sec.querySelector('[data-hint]');
      const defaultHint = hint?.textContent || '';
      const storeKey = 'sp-box-v1';
      let size = Number(sec.dataset.defaultSize) || 10;
      const isOff = (t) => !t || t.disabled || t.hasAttribute('data-off');
      let items = []; // array of variant ids, in slot order

      try {
        const saved = JSON.parse(localStorage.getItem(storeKey) || 'null');
        if (saved && Array.isArray(saved.items)) {
          size = sizes.some((s) => s.n === saved.size) ? saved.size : size;
          items = saved.items.filter((id) => byId[id] && !isOff(byId[id])).slice(0, size);
        }
      } catch (_) {}

      const save = () => { try { localStorage.setItem(storeKey, JSON.stringify({ size, items })); } catch (_) {} };
      const sizeInfo = () => sizes.find((s) => s.n === size) || {};

      const say = (msg, warn) => {
        if (!hint) return;
        hint.textContent = msg || defaultHint;
        hint.classList.toggle('is-warn', !!warn);
      };

      // Slot geometry inside the real MIX box (percent of the pack area). Packs stand fanned like in the real box.
      const PACK_AR = 193 / 420; // pack cut-out width / height
      const layout = (n) => {
        const box = slotsEl.getBoundingClientRect();
        const ar = box.width && box.height ? box.width / box.height : 1.2;
        const rots = [-6, 3, -2, 5, -4];
        const out = [];
        const row = (count, y, h, zBase, rowIdx) => {
          const w = (h * PACK_AR) / ar;            // pack width in % of area width
          const step = count > 1 ? (100 - w) / (count - 1) : 0;
          for (let i = 0; i < count; i++) out.push({ x: count > 1 ? i * step : (100 - w) / 2, y, h, r: rots[(i + rowIdx * 2) % rots.length], z: zBase + i });
        };
        if (n <= 5) row(n, 7, 86, 1, 0);
        else { const a = Math.ceil(n / 2); row(a, 0, 64, 1, 0); row(n - a, 36, 64, 20, 1); }
        return out;
      };

      const renderSlots = () => {
        slotsEl.innerHTML = '';
        layout(size).forEach((g, i) => {
          const b = document.createElement('button');
          b.type = 'button'; b.className = 'sp-slot'; b.dataset.slot = i; b.tabIndex = -1;
          b.style.cssText = `--x:${g.x}%;--y:${g.y}%;--h:${g.h}%;--r:${g.r}deg;z-index:${g.z}`;
          b.setAttribute('aria-label', L('empty_slot', 'Prázdne miesto {n}', { n: i + 1 }));
          slotsEl.appendChild(b);
        });
      };

      const fillSlot = (i, animate) => {
        const slot = slotsEl.children[i]; if (!slot) return;
        const id = items[i]; const t = id && byId[id];
        slot.innerHTML = '';
        slot.classList.toggle('is-filled', !!t);
        slot.tabIndex = t ? 0 : -1;
        if (!t) { slot.setAttribute('aria-label', L('empty_slot', 'Prázdne miesto {n}', { n: i + 1 })); return; }
        slot.setAttribute('aria-label', L('remove', 'Odobrať {name}', { name: t.dataset.name }));
        slot.innerHTML = `<img class="sp-slot__img${animate ? ' is-drop' : ''}" src="${t.dataset.img}" alt=""><span class="sp-slot__x" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M7 7l10 10M17 7 7 17" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg></span>`;
      };

      const update = () => {
        const n = items.length; const full = n >= size; const info = sizeInfo();
        sec.querySelectorAll('[data-count]').forEach((e) => (e.textContent = n));
        sec.querySelectorAll('[data-size-label]').forEach((e) => (e.textContent = size));
        sec.querySelectorAll('[data-dock-count]').forEach((e) => (e.textContent = L('dock_count', '{n} / {size} lízatiek', { n, size })));
        sec.querySelectorAll('[data-progress]').forEach((e) => (e.style.width = `${Math.min(100, (n / size) * 100)}%`));
        sec.querySelectorAll('.sp-builder__size').forEach((b) => b.setAttribute('aria-checked', Number(b.dataset.size) === size));

        // per-flavour counters
        const counts = items.reduce((a, id) => ((a[id] = (a[id] || 0) + 1), a), {});
        tiles.forEach((t) => {
          const c = counts[t.dataset.id] || 0;
          const li = t.closest('.sp-flavtile');
          const badge = li.querySelector('[data-count-for]');
          const minus = li.querySelector('[data-remove]');
          li.classList.toggle('is-in', c > 0);
          if (badge) { if (badge.textContent !== String(c) && c > 0) { badge.classList.remove('is-bump'); void badge.offsetWidth; badge.classList.add('is-bump'); } badge.textContent = c; badge.hidden = c === 0; }
          if (minus) minus.hidden = c === 0;
        });

        // price
        const priceEl = sec.querySelector('.sp-builder__price'); // nie [data-price]: ten atribút majú aj dlaždice príchutí
        if (priceEl) {
          if (info.box) {
            const per = Math.round(info.boxPrice / size);
            priceEl.innerHTML = `${info.boxCompare > info.boxPrice ? `<s>${formatMoney(info.boxCompare, fmt)}</s>` : ''}${formatMoney(info.boxPrice, fmt)}<small>${formatMoney(per, fmt)} / ${L('pcs', 'ks')} · ${L('box_size', 'box {n} ks', { n: size })}</small>`;
          } else if (mode === 'add') {
            const sum = items.reduce((a, id) => a + Number(byId[id]?.dataset.price || 0), 0);
            const final = Math.round(sum * (1 - discount / 100));
            priceEl.innerHTML = n ? `${discount ? `<s>${formatMoney(sum, fmt)}</s>` : ''}${formatMoney(final, fmt)}<small>${discount ? L('box_discount', '{d} % zľava za box', { d: discount }) : `${formatMoney(Math.round(final / n), fmt)} / ${L('pcs', 'ks')}`}</small>` : '';
          } else if (info.price) {
            const per = Math.round(info.price / size);
            priceEl.innerHTML = `${info.compare > info.price ? `<s>${formatMoney(info.compare, fmt)}</s>` : ''}${formatMoney(info.price, fmt)}<small>${formatMoney(per, fmt)} / ${L('pcs', 'ks')}</small>`;
          }
        }

        // buttons + lid
        sec.querySelectorAll('[data-cta]').forEach((b) => { b.disabled = !full; b.classList.toggle('is-ready', full); });
        sec.querySelectorAll('[data-cta-label]').forEach((e) => {
          if (!e.dataset.label) e.dataset.label = e.textContent;
          e.textContent = full ? e.dataset.label : (size - n === 1 ? L('left_1', 'Ešte {n} lízatko', { n: size - n }) : size - n < 5 ? L('left_few', 'Ešte {n} lízatká', { n: size - n }) : L('left_many', 'Ešte {n} lízatiek', { n: size - n }));
        });
        const clear = sec.querySelector('[data-clear]'); if (clear) clear.disabled = n === 0;
        const reopen = sec.querySelector('[data-reopen]'); if (reopen) reopen.hidden = !full;
        const random = sec.querySelector('[data-random]'); if (random) random.hidden = full;
        if (!full) box.classList.remove('is-closed');
        if (!full) say(n === 0 ? defaultHint : L('hint_progress', 'Super výber! Ešte {n} do plného boxu.', { n: size - n }));
        renderPanel(n, full, counts);
        refreshDetail();
        save();
      };


      /* ---------- Detail príchute (dialog) ---------- */
      const dlg = sec.querySelector('[data-detail-dialog]');
      let detailTile = null;
      const refreshDetail = () => {
        if (!dlg || !detailTile || !dlg.open) return;
        const c = items.filter((id) => id === detailTile.dataset.id).length;
        const full = items.length >= size;
        const btn = dlg.querySelector('[data-detail-add]');
        dlg.querySelector('[data-detail-inbox]').textContent = c ? L('in_box', 'V boxe: {c} ks · {n}/{size}', { c, n: items.length, size }) : L('box_count', 'Box: {n}/{size}', { n: items.length, size });
        btn.disabled = full || isOff(detailTile);
        btn.querySelector('span').textContent = isOff(detailTile) ? L('sold_out', 'Vypredané') : full ? L('box_full', 'Box je plný') : L('add_to_box', 'Pridať do boxu');
      };
      const openDetail = (t) => {
        if (!dlg) return add(t);
        const tpl = t.querySelector('template[data-detail]');
        dlg.querySelector('[data-detail-body]').innerHTML = tpl ? tpl.innerHTML : '';
        dlg.querySelector('[data-detail-body]').scrollTop = 0;
        detailTile = t;
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        document.documentElement.classList.add('sp-fd-open');
        refreshDetail();
      };
      const closeDetail = () => { if (dlg?.open) dlg.close(); };
      if (dlg) {
        dlg.addEventListener('close', () => { document.documentElement.classList.remove('sp-fd-open'); detailTile = null; });
        dlg.querySelector('[data-detail-close]').addEventListener('click', closeDetail);
        dlg.addEventListener('click', (e) => { if (e.target === dlg) closeDetail(); }); // klik mimo okna
        dlg.querySelector('[data-detail-add]').addEventListener('click', () => {
          if (!detailTile) return;
          // po pridaní sa okno zavrie a zákazník pokračuje vo výbere ďalších príchutí
          const t = detailTile; closeDetail(); add(t);
        });
      }

      /* ---------- Mobil: kompaktný panel boxu pod hlavičkou ---------- */
      const panel = sec.querySelector('[data-bpanel]');
      const boxPanel = sec.querySelector('[data-box-panel]');
      const panelMore = panel?.querySelector('[data-bpanel-more]');
      const panelToggle = panel?.querySelector('[data-bpanel-toggle]');
      const mq = window.matchMedia('(max-width: 899px)');
      const setPanelOpen = (open) => {
        if (!panel) return;
        panelToggle.setAttribute('aria-expanded', open); panelMore.hidden = !open; panel.classList.toggle('is-open', open);
      };
      const renderPanel = (n, full, counts) => {
        if (!panel) return;
        panel.querySelector('[data-panel-count]').textContent = `${n} / ${size}`;
        panel.querySelector('[data-panel-sub]').textContent = full ? L('panel_full', 'Box je plný 🎉') : n ? L('panel_left', 'ešte {n} do plného boxu', { n: size - n }) : L('panel_empty', 'lízatiek v boxe');
        panel.classList.toggle('is-full', full);
        const thumbs = panel.querySelector('[data-panel-thumbs]');
        thumbs.innerHTML = items.slice(0, 10).map((id) => `<img src="${byId[id]?.dataset.img || ''}" alt="">`).join('');
        const grid = panel.querySelector('[data-panel-grid]');
        let html = '';
        for (let i = 0; i < size; i++) {
          const t = byId[items[i]];
          html += t
            ? `<li><button type="button" class="sp-bpanel__slot is-filled" data-panel-slot="${i}" aria-label="${L('remove', 'Odobrať {name}', { name: t.dataset.name })}"><img src="${t.dataset.img}" alt=""><span aria-hidden="true">×</span></button></li>`
            : `<li><span class="sp-bpanel__slot" aria-hidden="true"></span></li>`;
        }
        grid.innerHTML = html;
      };
      const syncPanel = () => {
        if (!panel || !boxPanel) return;
        const r = boxPanel.getBoundingClientRect(); const s2 = sec.getBoundingClientRect();
        const hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sp-header-h')) || 0;
        panel.style.setProperty('--top', `${hh}px`);
        const show = mq.matches && r.bottom < hh + 24 && s2.bottom > hh + 160;
        if (show === !panel.hidden) return;
        panel.hidden = !show;
        if (!show) setPanelOpen(false);
      };
      if (panel) {
        panelToggle.addEventListener('click', () => setPanelOpen(panelMore.hidden));
        panel.querySelector('[data-panel-grid]').addEventListener('click', (e) => {
          const b = e.target.closest('[data-panel-slot]'); if (!b) return;
          removeAt(Number(b.dataset.panelSlot));
        });
        panel.querySelector('[data-panel-box]').addEventListener('click', () => {
          setPanelOpen(false);
          const hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sp-header-h')) || 0;
          window.scrollTo({ top: boxPanel.getBoundingClientRect().top + scrollY - hh - 12, behavior: reduce ? 'auto' : 'smooth' });
        });
        panel.querySelector('[data-panel-clear]').addEventListener('click', () => { items = []; setSize(size); });
        let ticking = false;
        const onScroll = () => { if (ticking) return; ticking = true; requestAnimationFrame(() => { ticking = false; syncPanel(); }); };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
      }

      const confetti = () => {
        if (reduce) return;
        const host = sec.querySelector('[data-confetti]'); if (!host) return;
        const colors = ['#e5609a', '#48bda5', '#ffd23f', '#a68be0', '#2453d6', '#ff7a2f'];
        for (let i = 0; i < 36; i++) {
          const c = document.createElement('span'); c.className = 'sp-confetti';
          c.style.background = colors[i % colors.length];
          host.appendChild(c);
          const a = Math.random() * Math.PI * 2; const d = 90 + Math.random() * 160;
          c.animate([
            { transform: 'translate(-50%,-50%) scale(.4) rotate(0deg)', opacity: 1 },
            { transform: `translate(calc(-50% + ${Math.cos(a) * d}px), calc(-50% + ${Math.sin(a) * d - 40}px)) scale(1) rotate(${Math.random() * 540}deg)`, opacity: 1, offset: .7 },
            { transform: `translate(calc(-50% + ${Math.cos(a) * d * 1.1}px), calc(-50% + ${Math.sin(a) * d + 60}px)) scale(.8) rotate(${Math.random() * 720}deg)`, opacity: 0 },
          ], { duration: 1300 + Math.random() * 500, easing: 'cubic-bezier(.2,.8,.2,1)' }).onfinish = () => c.remove();
        }
      };

      const completeIfFull = () => {
        if (items.length < size) return;
        setTimeout(() => {
          box.classList.add('is-closed');
          confetti();
          say(L('done', 'Hotovo! Tvoj box je plný. 🎉'));
        }, reduce ? 0 : 380);
      };

      const fly = (tile, slotIndex, done) => {
        const slot = slotsEl.children[slotIndex];
        const src = tile.querySelector('.sp-flavtile__img');
        if (reduce || !slot || !src || !slot.animate) return done();
        const a = src.getBoundingClientRect(); const b = slot.getBoundingClientRect();
        // Krabica mimo obrazovky: na mobile letí lízatko do panelu, inak bez animácie
        if (b.bottom < 0 || b.top > innerHeight) {
          const tgt = panel && !panel.hidden ? panel.querySelector('.sp-bpanel__icon') : null;
          if (!tgt) return done();
          const pb = tgt.getBoundingClientRect();
          const el2 = document.createElement('div'); el2.className = 'sp-fly';
          el2.style.cssText = `left:${a.left}px;top:${a.top}px;width:${a.width}px;height:${a.height}px`;
          el2.innerHTML = `<img src="${tile.dataset.img}" alt="">`; document.body.appendChild(el2);
          const ddx = pb.left + pb.width / 2 - (a.left + a.width / 2); const ddy = pb.top + pb.height / 2 - (a.top + a.height / 2);
          el2.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: `translate(${ddx}px, ${ddy}px) scale(.18)`, opacity: .6 }],
            { duration: 480, easing: 'cubic-bezier(.45,0,.2,1)' }).onfinish = () => { el2.remove(); panel.classList.remove('is-bump'); void panel.offsetWidth; panel.classList.add('is-bump'); done(); };
          return;
        }
        const el = document.createElement('div'); el.className = 'sp-fly';
        el.style.cssText = `left:${a.left}px;top:${a.top}px;width:${a.width}px;height:${a.height}px`;
        el.innerHTML = `<img src="${tile.dataset.img}" alt="">`;
        document.body.appendChild(el);
        const dx = b.left + b.width / 2 - (a.left + a.width / 2);
        const dy = b.top + b.height / 2 - (a.top + a.height / 2);
        const s = Math.min(b.width / a.width, b.height / a.height);
        el.animate([
          { transform: 'translate(0,0) scale(1) rotate(0deg)' },
          { transform: `translate(${dx * .5}px, ${dy * .5 - 80}px) scale(${(1 + s) / 2}) rotate(-12deg)`, offset: .55 },
          { transform: `translate(${dx}px, ${dy}px) scale(${s}) rotate(0deg)` },
        ], { duration: 560, easing: 'cubic-bezier(.45,0,.2,1)' }).onfinish = () => { el.remove(); done(); };
      };

      const add = (tile) => {
        if (isOff(tile)) return;
        if (items.length >= size) {
          box.classList.remove('is-shake'); void box.offsetWidth; box.classList.add('is-shake');
          say(L('full_warn', 'Box je plný. Odober lízatko alebo zvoľ väčší box.'), true);
          return;
        }
        items.push(tile.dataset.id);
        const i = items.length - 1;
        update();
        fly(tile, i, () => { fillSlot(i, true); completeIfFull(); });
      };

      const removeAt = (i) => {
        if (i < 0 || i >= items.length) return;
        items.splice(i, 1);
        for (let k = i; k < size; k++) fillSlot(k, false);
        update();
      };

      const removeOne = (id) => { const i = items.lastIndexOf(id); removeAt(i); };

      const setSize = (n) => {
        size = n;
        if (items.length > size) items = items.slice(0, size);
        renderSlots(); items.forEach((_, i) => fillSlot(i, false));
        update(); completeIfFull();
      };

      // events
      tiles.forEach((t) => {
        const quick = t.querySelector('[data-quick]');
        if (!quick) { t.addEventListener('click', () => add(t)); return; } // starší vzhľad dlaždice: celá dlaždica pridáva
        quick.addEventListener('click', () => add(t));
        t.querySelectorAll('[data-open]').forEach((b) => b.addEventListener('click', () => openDetail(t)));
      });
      sec.querySelectorAll('[data-remove]').forEach((b) => b.addEventListener('click', () => removeOne(b.dataset.remove)));
      slotsEl.addEventListener('click', (e) => {
        const slot = e.target.closest('.sp-slot.is-filled'); if (!slot) return;
        removeAt(Number(slot.dataset.slot));
      });
      sec.querySelectorAll('.sp-builder__size').forEach((b) => b.addEventListener('click', () => setSize(Number(b.dataset.size))));
      sec.querySelector('[data-clear]')?.addEventListener('click', () => { items = []; setSize(size); });
      sec.querySelector('[data-reopen]')?.addEventListener('click', () => { box.classList.remove('is-closed'); say(L('reopen', 'Ťukni na lízatko v boxe a vymeň ho.')); });
      sec.querySelector('[data-random]')?.addEventListener('click', () => {
        const pool = tiles.filter((t) => !isOff(t));
        if (!pool.length) return;
        const missing = size - items.length;
        for (let k = 0; k < missing; k++) items.push(pool[Math.floor(Math.random() * pool.length)].dataset.id);
        items.forEach((_, i) => fillSlot(i, i >= size - missing));
        update(); completeIfFull();
      });

      sec.querySelectorAll('[data-cta]').forEach((btn) => btn.addEventListener('click', async () => {
        if (items.length < size) return;
        save();
        const info = sizeInfo();
        if (!info.box && mode !== 'add') {
          const url = sizeInfo().url;
          if (url) window.location.href = url;
          return;
        }
        // Mix Box produkt: JEDNA položka, zloženie ako vlastnosti položky (vidno ich v košíku, pokladni aj objednávke).
        // Rovnaké zloženie = rovnaká položka (počet sa zvýši), iné zloženie = nová položka.
        // Inak (bez produktu Mix Box) starý režim 'add': jednotlivé lízatká.
        const grouped = items.reduce((a, id) => ((a[id] = (a[id] || 0) + 1), a), {});
        let payload;
        if (info.box) {
          const properties = {};
          tiles.forEach((t) => { const c = grouped[t.dataset.id]; if (c) properties[t.dataset.name.replace(/&amp;/g, '&')] = `× ${c}`; });
          payload = { items: [{ id: Number(info.box), quantity: 1, properties }] };
        } else {
          const boxId = `Box ${size} ks · ${Date.now().toString(36).slice(-5).toUpperCase()}`;
          payload = { items: Object.entries(grouped).map(([id, quantity]) => ({ id: Number(id), quantity, properties: { _box: boxId } })) };
        }
        const util = themeUtil(); const ev = themeEvents();
        const hasDrawer = !!document.querySelector('cart-drawer, cart-drawer-component');
        let sections = '';
        try { if (hasDrawer && util?.sectionRenderUtil) sections = util.sectionRenderUtil('cart-drawer').getSectionsString(); } catch (_) {}
        btn.disabled = true;
        try {
          const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js${sections ? `?sections=${sections}` : ''}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(payload),
          });
          const data = await res.json();
          if (!res.ok) throw data;
          items = []; setSize(size);
          if (hasDrawer && util?.dispatchCustomEvent && ev) {
            util.dispatchCustomEvent(ev.triggerCartChange, btn, { sections: data.sections });
            util.dispatchCustomEvent(ev.showDrawer, document, { drawerType: 'cart-drawer' });
          } else {
            window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
          }
        } catch (err) {
          say(err?.description || L('cart_fail', 'Box sa nepodarilo pridať do košíka.'), true);
        } finally { btn.disabled = items.length < size; }
      }));

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([e]) => document.documentElement.classList.toggle('sp-builder-inview', e.isIntersecting)).observe(sec);
      }
      let rz; window.addEventListener('resize', () => { clearTimeout(rz); rz = setTimeout(() => { renderSlots(); items.forEach((_, i) => fillSlot(i, false)); }, 200); }, { passive: true });

      renderSlots(); items.forEach((_, i) => fillSlot(i, false)); update(); syncPanel?.();
      // Štítky pod nadpisom: plynulý posun na výber veľkosti / príchutí a krátke zvýraznenie
      sec.querySelectorAll('[data-sp-chip]').forEach((a2) => a2.addEventListener('click', (e) => {
        const t = sec.querySelector(a2.getAttribute('href')); if (!t) return;
        e.preventDefault();
        // posun pod hlavičku; pri výbere príchutí na mobile aj pod kompaktný panel boxu
        const hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sp-header-h')) || 0;
        const extra = mq.matches && t.contains(sec.querySelector('[data-flavour]')) ? 72 : 0;
        window.scrollTo({ top: t.getBoundingClientRect().top + scrollY - hh - extra - 12, behavior: reduce ? 'auto' : 'smooth' });
        t.classList.remove('is-flash'); void t.offsetWidth; t.classList.add('is-flash');
      }));
      if (items.length >= size) { box.classList.add('is-closed'); say(L('done', 'Hotovo! Tvoj box je plný. 🎉')); }
    });
  };

  /* ---------- Hero parallax (desktop, fine pointer only) ---------- */
  const initParallax = (root) => {
    if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    root.querySelectorAll('[data-sp-parallax]').forEach((el) => {
      const host = el.closest('section') || el;
      let raf;
      host.addEventListener('pointermove', (e) => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const r = host.getBoundingClientRect();
          el.style.setProperty('--mx', ((e.clientX - r.left) / r.width - .5).toFixed(3));
          el.style.setProperty('--my', ((e.clientY - r.top) / r.height - .5).toFixed(3));
        });
      });
      host.addEventListener('pointerleave', () => { el.style.setProperty('--mx', 0); el.style.setProperty('--my', 0); });
    });
  };

  /* ---------- In-page links: smooth scroll below the sticky header ---------- */
  const headerOffset = () => {
    setHeaderH();
    const h = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sp-header-h')) || 0;
    return h + 20;
  };
  const scrollToTarget = (target, focus) => {
    const y = target.getBoundingClientRect().top + window.scrollY - headerOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    // Re-align once the smooth scroll ends (late-loading images above can shift the target)
    const fix = () => {
      const d = target.getBoundingClientRect().top - headerOffset();
      if (Math.abs(d) > 6) window.scrollBy({ top: d, behavior: 'auto' });
    };
    if (!reduce) { if ('onscrollend' in window) window.addEventListener('scrollend', fix, { once: true }); else setTimeout(fix, 900); }
    target.classList.remove('is-target'); void target.offsetWidth; target.classList.add('is-target');
    if (focus) { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
  };
  const initAnchors = () => {
    if (window.__spAnchors) return; window.__spAnchors = true;
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href*="#"]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey) return;
      const url = new URL(a.href, location.href);
      if (url.pathname !== location.pathname || !url.hash || url.hash === '#') return;
      const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!target) return;
      e.preventDefault();
      history.replaceState(null, '', url.hash);
      scrollToTarget(target, true);
    });
    if (location.hash) {
      const t = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (t) setTimeout(() => scrollToTarget(t), 350);
    }
  };

  /* ---------- Explanation sheets (USP cards) ---------- */
  const initSheets = () => {
    if (window.__spSheets) return; window.__spSheets = true;
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-sp-sheet-open]');
      if (opener) {
        const d = document.getElementById(opener.dataset.spSheetOpen);
        if (d && typeof d.showModal === 'function') { d.showModal(); document.documentElement.style.overflow = 'hidden'; }
        return;
      }
      const closer = e.target.closest('[data-sp-sheet-close]');
      const dlg = e.target.closest('dialog.sp-sheet') || (e.target.matches && e.target.matches('dialog.sp-sheet') ? e.target : null);
      if (closer && dlg) { dlg.close(); document.documentElement.style.overflow = ''; return; }
      if (e.target.matches && e.target.matches('dialog.sp-sheet')) { e.target.close(); document.documentElement.style.overflow = ''; } // backdrop click
    }, true); // capture: close the sheet before in-page anchor scrolling runs
    document.addEventListener('close', (e) => { if (e.target.matches && e.target.matches('dialog.sp-sheet')) document.documentElement.style.overflow = ''; }, true);
  };

  const init = (root = document) => {
    setHeaderH(); initReveal(root); initTabs(root); initRails(root); initFlavours(root); initQuickAdd(root); initHeroSlides(root); initBuilder(root); initParallax(root); initAnchors(); initSheets();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  window.addEventListener('resize', setHeaderH, { passive: true });

  // Re-init sections when edited in the theme editor
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
